"use strict";
exports.__esModule = true;
exports.getOperationType = void 0;
var logs_1 = require("@ledgerhq/logs");
/**
 * Returns the operation type by using his palletMethod
 * the method case depends from which indexer you are using
 *
 * @param {*} pallet
 * @param {*} palletMethod
 *
 * @returns {string} - OperationType
 */
var getOperationType = function (pallet, palletMethod) {
    switch (palletMethod) {
        case "transfer":
        case "transferKeepAlive":
            return "OUT";
        case "bond":
        case "bondExtra":
        case "rebond":
            return "BOND";
        case "unbond":
            return "UNBOND";
        case "nominate":
            return "NOMINATE";
        case "chill":
            return "CHILL";
        case "withdrawUnbonded":
            return "WITHDRAW_UNBONDED";
        case "setController":
            return "SET_CONTROLLER";
        case "payoutStakers":
            return "FEES";
        default:
            (0, logs_1.log)("polkadot/api", "Unknown operation type ".concat(pallet, ".").concat(palletMethod, " - fallback to FEES"));
            return "FEES";
    }
};
exports.getOperationType = getOperationType;
//# sourceMappingURL=common.js.map